import React from 'react';
import { Layout, Menu, Dropdown, Avatar, Space, Typography } from 'antd';
import { UserOutlined, DownOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../features/auth/authSlice';

const { Header } = Layout;
const { Text, Title } = Typography;

const HeaderComponent = () => {
  const {
    user,
  } = useSelector((state) => state.auth);
  const userRoles = useSelector((state) => state.auth?.user?.data?.roles)
  const location = useLocation()
  const navigate = useNavigate()
  const isTouch = window.matchMedia("(pointer: coarse)").matches;

  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logout());
    navigate('/login')
  }


  const inboundRawMenu = [
    {
      key: '0',
      allowedRole: ["admin"],
      label: (
        <a href="/purchase-requisition">
          Purchase Requisition (PR)
        </a>
      ),
    },
    {
      key: '1',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/purchase-order">
          Purchase Order (PO)
        </a>
      ),
    },
    {
      key: '2',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/quality-check">
          Quality Check (QC)
        </a>
      ),
      // icon: <SmileOutlined />,
      // disabled: true,
    },
    {
      key: '3',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/receiving-report">
          Receiving Item (RI)
        </a>
      ),
    },
    {
      key: '4',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/put-away">
          Put Away
        </a>
      ),
    }
  ]

  const inboundMenu = userRoles?.includes("root")
    ? inboundRawMenu
    : inboundRawMenu?.filter(item =>
      Array.isArray(item?.allowedRole) && item?.allowedRole?.some(role => userRoles?.includes(role))
    );

  const outboundRawMenu = [
    {
      key: '0',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/sales-order">
          Sales Order (SO)
        </a>
      ),
    },
    {
      key: '1',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/delivery-order">
          Delivery Order (DO)
        </a>
      ),
    },
    // {
    //   key: '2',
    //   label: (
    //     <a href="/delivery-order/approval-list">
    //       Delivery Order Approval
    //     </a>
    //   ),
    // },
    {
      key: '3',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/pickpack">
          Pick & Pack
        </a>
      ),
    },
    // {
    //   key: '4',
    //   label: (
    //     <a href="/walk-order">
    //       Walk Order
    //     </a>
    //   ),
    // }
  ]

  const outboundMenu = userRoles?.includes("root")
    ? outboundRawMenu
    : outboundRawMenu?.filter(item =>
      Array.isArray(item?.allowedRole) && item?.allowedRole?.some(role => userRoles?.includes(role))
    );

  const inventoryRawMenu = [
    {
      key: '1',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/inventory">
          Inventory List
        </a>
      ),
    },
    // {
    //   key: '2',
    //   label: (
    //     <a href="/inventory-detail">
    //       Inventory Detail
    //     </a>
    //   ),
    // }
  ]

  const inventoryMenu = userRoles?.includes("root")
    ? inventoryRawMenu
    : inventoryRawMenu?.filter(item =>
      Array.isArray(item?.allowedRole) && item?.allowedRole?.some(role => userRoles?.includes(role))
    );

  const invoiceRawMenu = [
    {
      key: '1',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/sales-invoice">
          Sales Invoice
        </a>
      ),
    },
  ]

  const invoiceMenu = userRoles?.includes("root")
    ? invoiceRawMenu
    : invoiceRawMenu?.filter(item =>
      Array.isArray(item?.allowedRole) && item?.allowedRole?.some(role => userRoles?.includes(role))
    );

  const reportRawMenu = [
    {
      key: '1',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/report-inventory-balance">
          Inventory Balance
        </a>
      ),
    },
    {
      key: '2',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/report-inventory-aging">
          Inventory Aging
        </a>
      ),
    },
    {
      key: '3',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/report-inventory-exp-date">
          Inventory Expired Date
        </a>
      ),
    },
    {
      key: '4',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/report-transaction-inventory">
          Transaction Inventory
        </a>
      ),
    },
    {
      key: '5',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/report-transaction-inventory-detail">
          Transaction Inventory Detail
        </a>
      ),
    }
  ]

  const reportMenu = userRoles?.includes("root")
    ? reportRawMenu
    : reportRawMenu?.filter(item =>
      Array.isArray(item?.allowedRole) && item?.allowedRole?.some(role => userRoles?.includes(role))
    );

  const adjustmentRawMenu = [
    {
      key: '1',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/adjustment-quantity">
          Adjustment Quantity
        </a>
      ),
    },
    // {
    //   key: '2',
    //   label: (
    //     <a href="/adjustment-expired">
    //       Adjustment Expired Date
    //     </a>
    //   ),
    // }
  ]

  const adjustmentMenu = userRoles?.includes("root")
    ? adjustmentRawMenu
    : adjustmentRawMenu?.filter(item =>
      Array.isArray(item?.allowedRole) && item?.allowedRole?.some(role => userRoles?.includes(role))
    );

  const masterDataRawMenu = [
    {
      key: '1',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/customer">
          Customer
        </a>
      ),
    },
    {
      key: '2',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/category">
          Category
        </a>
      ),
      // icon: <SmileOutlined />,
      // disabled: true,
    },
    {
      key: '3',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/product">
          Product (SKU)
        </a>
      ),
    },
    {
      key: '4',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/supplier">
          Supplier
        </a>
      ),
    },
    {
      key: '5',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/location">
          Location
        </a>
      ),
    },
    {
      key: '6',
      allowedRole: ["admin", "staff"],
      label: (
        <a href="/shipping">
          Shipping
        </a>
      ),
    }
  ]

  const masterDataMenu = userRoles?.includes("root")
    ? masterDataRawMenu
    : masterDataRawMenu?.filter(item =>
      Array.isArray(item?.allowedRole) && item?.allowedRole?.some(role => userRoles?.includes(role))
    );

  const dropdownUserRawMenu = [
    {
      key: '0',
      label: (
        <div className='text-lg'>{user?.data?.name}</div>
      ),
      disabled: true,
      touchOnly: true
    },
    {
      key: '-',
      type: 'divider',
      touchOnly: true
    },
    {
      key: '4',
      label: (
        <a href="/user-management">
          User Management
        </a>
      ),
    },
    {
      key: '1',
      allowedRole: ["admin"],
      label: (
        <a href="/webhook">
          Webhook
        </a>
      ),
    },
    {
      key: '3',
      allowedRole: ["admin"],
      label: (
        <a href="/app-settings">
          App Setting
        </a>
      ),
    },
    {
      key: '2',
      allowedRole: ["admin", "staff"],
      label: (
        <a onClick={handleLogout}>
          Logout
        </a>
      ),
    },
  ]

  const dropdownUserMenu = userRoles?.includes('root')
    ? dropdownUserRawMenu.filter(item => isTouch || !item.touchOnly)
    : dropdownUserRawMenu.filter(
      item =>
        Array.isArray(item?.allowedRole) &&
        item?.allowedRole?.some(role => userRoles?.includes(role)) &&
        (isTouch || !item.touchOnly)
    );

  return (
    location?.pathname.includes('login') ||  location?.pathname.includes('reset-password')?
      <Header className="bg-primary-500 text-center h-fit">
        <h1 className="text-primary-text text-4xl font-medium py-6">WMS</h1>
      </Header>
      :

      <Header className="bg-primary-500 flex gap-10 justify-between items-center px-6">
        <div className="w-full flex items-center justify-between">
          <div className="w-1/6">
            {/* <img src="/path-to-logo.png" alt="Logo" className="w-12" /> */}
            <h1 className="text-primary-text text-xl font-medium" level={3}>WMS</h1>
          </div>
          <Space className={`w-5/6 justify-center ${isTouch && "gap-4"} lg:gap-8`}>
            <div>
              <a href="/" className='text-primary-text whitespace-nowrap'>
                Dashboard
              </a>
            </div>
            {inboundMenu.length > 0 &&
              <Dropdown
                menu={{
                  items: inboundMenu
                }}
              >
                <a onClick={(e) => e.preventDefault()} className="text-white whitespace-nowrap">
                  <div>
                    Inbound <DownOutlined className='text-xs' />
                  </div>
                </a>
              </Dropdown>
            }
            {outboundMenu.length > 0 &&
              <Dropdown
                menu={{
                  items: outboundMenu
                }}
              >
                <a onClick={(e) => e.preventDefault()} className="text-white whitespace-nowrap">
                  <div>
                    Outbound <DownOutlined className='text-xs' />
                  </div>
                </a>
              </Dropdown>
            }
            {inventoryMenu.length > 0 &&
              <Dropdown
                menu={{
                  items: inventoryMenu
                }}
              >
                <a onClick={(e) => e.preventDefault()} className="text-white whitespace-nowrap">
                  <div>
                    Inventory <DownOutlined className='text-xs' />
                  </div>
                </a>
              </Dropdown>
            }
            {invoiceMenu.length > 0 &&
              <Dropdown
                menu={{
                  items: invoiceMenu
                }}
              >
                <a onClick={(e) => e.preventDefault()} className="text-white whitespace-nowrap">
                  <div>
                    Invoice <DownOutlined className='text-xs' />
                  </div>
                </a>
              </Dropdown>
            }
            {reportMenu.length > 0 &&
              <Dropdown
                menu={{
                  items: reportMenu
                }}
              >
                <a onClick={(e) => e.preventDefault()} className="text-white whitespace-nowrap">
                  <div>
                    Report <DownOutlined className='text-xs' />
                  </div>
                </a>
              </Dropdown>
            }
            {adjustmentMenu.length > 0 &&
              <Dropdown
                menu={{
                  items: adjustmentMenu
                }}
              >
                <a onClick={(e) => e.preventDefault()} className="text-white whitespace-nowrap">
                  <div>
                    Adjustment <DownOutlined className='text-xs' />
                  </div>
                </a>
              </Dropdown>
            }
            {masterDataMenu.length > 0 &&
              <Dropdown
                menu={{
                  items: masterDataMenu
                }}
              >
                <a onClick={(e) => e.preventDefault()} className="text-white  whitespace-nowrap">
                  <div>
                    Master Data <DownOutlined className='text-xs' />
                  </div>
                </a>
              </Dropdown>
            }
          </Space>
        </div>
        <div className="flex items-center  justify-end">
          <Dropdown
            menu={{
              items: dropdownUserMenu,
            }}
          >
            <div className='cursor-pointer whitespace-nowrap'>
              <Avatar icon={<UserOutlined />} src="/path-to-profile-photo.png" />
              {!isTouch &&
                <Text className="ml-2 text-white cursor-pointer">{user?.data?.name}</Text>
              }
            </div>
          </Dropdown>
        </div>
      </Header>
  )
}

export default HeaderComponent